module.exports = __webpack_public_path__ + "static/media/smartobject_circles.5a8d6fed.png";